<section class="vps-hero radius4">
  <img [src]="heroSrc" [alt]="heroAlt" />
</section>

<!-- Selector vertical SSD + panel -->
<section class="vps-plans-joomla" id="plans" *ngIf="plans.length">
  <div class="vps-plans-shell">
    <nav class="vps-ssd-nav" aria-label="Seleccionar plan SSD">
      <button
        *ngFor="let p of plans; let i = index"
        type="button"
        class="vps-ssd-nav-btn"
        [class.is-active]="selectedPlanIndex === i"
        [style.--ssd-accent]="tabAccent(i)"
        (click)="selectPlan(i)">
        <span class="vps-ssd-nav-name">{{ p.name }}</span>
        <span class="vps-ssd-nav-disk">{{ diskSubtitle(p) }}</span>
      </button>
    </nav>

    <div class="vps-ssd-panel" *ngIf="plans[selectedPlanIndex] as plan">
      <div class="vps-ssd-panel-main">
        <h2 class="vps-ssd-ram">
          <span class="vps-ssd-ram-gb">{{ ramParts(plan).gb }}</span>
          <span *ngIf="ramParts(plan).ram" class="vps-ssd-ram-lbl">{{ ramParts(plan).ram }}</span>
        </h2>
        <p class="vps-ssd-disk-line">{{ diskSubtitle(plan) }}</p>

        <table class="vps-spec-table" aria-label="Especificaciones del plan">
          <tbody>
            <tr *ngFor="let f of plan.features">
              <th scope="row">{{ f.label }}</th>
              <td>{{ f.value }}</td>
            </tr>
          </tbody>
        </table>

        <p class="vps-ssd-plan-label">VPS Plan {{ selectedPlanIndex + 1 }}</p>
      </div>

      <div class="vps-ssd-panel-visual">
        <img loading="lazy" [src]="vpsPlanImageUrl" [alt]="'Servidor VPS — ' + plan.name" width="323" height="220" />
        <div class="vps-price-strips">
          <div
            *ngFor="let c of plan.contracts; let ri = index"
            class="vps-price-strip"
            [style.background]="priceStripBg(selectedPlanIndex, ri)">
            <span class="vps-price-strip-lbl">{{ c.label }}</span>
            <span class="vps-price-strip-val">{{ cart.symbol }} {{ c.monthlyPrice | rackeoCurrency }} / Mensual</span>
          </div>
        </div>

        <div class="vps-ssd-cta">
          <a [href]="cart.buildProductUrl(plan)" target="_blank" rel="noopener noreferrer">Comprar</a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="vps-page-tabs radius4" id="plans_text">
  <div class="tabs-vps-wrap">
    <header class="tabs-vps-head">
      <h1 class="tabs-vps-title">Planes VPS</h1>
      <div class="tabs-vps-toolbar">
        <h2 class="tabs-vps-section-title">{{ tabSectionTitles[activeTab] }}</h2>
        <div class="tabs-vps-pills" role="tablist">
          <div *ngFor="let label of tabPills; let i = index">
            <button
              type="button"
              role="tab"
              [attr.aria-selected]="activeTab === i"
              [class.is-active]="activeTab === i"
              (click)="setTab(i)">
              {{ label }}
            </button>
          </div>
        </div>
      </div>
    </header>

    <div class="tabs-vps-body" [ngSwitch]="activeTab">
      <!-- Generales -->
      <div *ngSwitchCase="0" class="tabs-vps-panel vps-panel-gen">
        <div class="vps-gen-grid">
          <aside class="vps-gen-fibra" aria-label="Conectividad">
            <div class="vps-gen-fibra-box">
              <div class="vps-gen-fibra-top">
                <div class="vps-gen-fibra-photo-wrap">
                  <img
                    src="assets/images/rackeo/virtualizacion/generales/vps-generales-fibra-optica.png"
                    alt="Enlace de fibra óptica en Data Center Rackeo"
                    loading="lazy" />
                </div>
                <h3 class="vps-gen-fibra-title">ENLACE DE FIBRA ÓPTICA</h3>
              </div>
              <p class="vps-gen-fibra-desc">
                Nuestro Data Center propio cuenta con enlace de fibra óptica propia, la que nos entrega una excelente conectividad y una mayor velocidad de conexión.
              </p>
            </div>
          </aside>
          <div class="vps-gen-main">
          <article class="vps-gen-block">
            <h3>SOFTWARE COMPATIBLES</h3>
            <ul>
              <li>Múltiples distribuciones Linux como CentOS, Debian, Ubuntu o FreeBSD (64-bit with 32-bit Compatibility).</li>
              <li>Con Linux puedes obtener un panel de control (Parallels® Plesk Panel, cPanel) para administrar tu servidor.</li>
              <li>Opcional cPanel con WHM Control Panel.</li>
              <li>Apache Web Server, MySQL, PHP, Perl, Python (Django), Ruby (on Rails), FFMpeg.</li>
              <li>Xen, OpenVZ y Hardware Virtual Machine.</li>
              <li>Habilitado para instalar y personalizar aplicaciones.</li>
            </ul>
          </article>
          <article class="vps-gen-block">
            <h3>TECNOLOGÍA EN SERVIDORES</h3>
            <ul>
              <li>Dell PowerEdge Servers.</li>
              <li>Especificaciones del hardware personalizadas.</li>
              <li>Dual Nehalem CPUs (16 Hyperthreaded cores).</li>
              <li>Tolerancia a fallos RAID-10 Disk Array con drives de la empresa.</li>
              <li>DDR3 ECC RAM.</li>
            </ul>
          </article>
          <article class="vps-gen-block">
            <h3>ADMINISTRACIÓN VPS</h3>
            <ul>
              <li>Panel de control para administrar tu VPS: reiniciar, apagar, prender y configurar.</li>
              <li>Acceso completo root, a través de SSH y consola.</li>
              <li>Estadísticas del uso de CPU, RAM y transferencia.</li>
              <li>Tecnología de virtualización Xen, OpenVZ y HVM.</li>
            </ul>
          </article>
          </div>
        </div>

        <div class="vps-gen-sabias">
          <div class="vps-gen-sabias-text">
            <h3>SABIAS QUE…</h3>
            <p>
              <strong>¿Qué es la transferencia mensual?</strong>
              La transferencia mensual es el volumen de tráfico de su sitio. Nuestros servidores miden el tráfico realizado desde o hacia su cuenta de hosting, la suma de ellos será su uso total. Su cuota se renueva cada inicio de mes. Por ejemplo, si sube un archivo de 20KB (kilo bytes) en su sitio web y recibe visitas que descargan o ven la imagen, cada usuario sumará 20KB a su uso de Transferencia Mensual.
            </p>
          </div>
        </div>
      </div>

      <!-- Características -->
      <div *ngSwitchCase="1" class="tabs-vps-panel vps-panel-carac">
        <div class="vps-carac-grid">
          <div class="vps-carac-main">
            <article class="vps-carac-block">
              <img loading="lazy" src="assets/images/rackeo/virtualizacion/caracteristicas/vps-carac-techno.png" alt="Tecnología de virtualización Xen, OpenVZ y HVM" />
              <div>
                <h3>TECNOLOGÍA DE VIRTUALIZACIÓN</h3>
                <p>
                  Nuestra tecnología de virtualización es compatible con multiples distribuciones de Linux (CentOS, Debian, Ubuntu o FreeBSD). Además con Linux puedes obtener un panel de control (Parallels®Plesk Panel, cPanel) que te ayudara a administrar tu servidor. Nuestros servidores estan virtualizados gracias Xen, OpenVZ y HVM .
                </p>
              </div>
            </article>
            <article class="vps-carac-block">
              <img loading="lazy" src="assets/images/rackeo/virtualizacion/caracteristicas/vps-carac-admin.png" alt="Panel de administración del VPS con acceso root" />
              <div>
                <h3>ADMINISTRACIÓN VPS</h3>
                <p>
                  Podras a través de un panel administrar tu VPS totalmente, reiniciar, apagar, prender y configurarlo con acceso completo Root, a través de SSH y Consola, además en este panel podras encontrar estadisticas del uso de CPU , RAM y transferencia de tu VPS.
                </p>
              </div>
            </article>
            <article class="vps-carac-block">
              <img loading="lazy" src="assets/images/rackeo/virtualizacion/caracteristicas/vps-carac-soporte.png" alt="Soporte de emergencia Rackeo para planes VPS" />
              <div>
                <h3>SOPORTE</h3>
                <p>
                  Todos nuestros VPS tienen el Nivel 1 de Soporte el cual te otorga la capacidad de soporte de asistencia de emergencias, y de un seguro de Rackeo por sorpresas desagradables, además de esto siempre podras contar con nuestro equipo de profesionales para resolver cualquier tipo de problema que se le presente.
                </p>
              </div>
            </article>
            <article class="vps-carac-block">
              <img loading="lazy" src="assets/images/rackeo/virtualizacion/caracteristicas/vps-carac-data.png" alt="Data center propio Rackeo con enlace de fibra óptica" />
              <div>
                <h3>DATA CENTER</h3>
                <p>
                  Nuestro Data Center propio ha sido instalado con los más altos estándares: cuenta con enlace de fibra óptica, grupo electrógeno de respaldo, sistema de refrigeración redundante, UPS para todos nuestros servidores, balanceo de cargas redundantes además de enlace nacional de 1 GB.
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>

      <!-- Comparar -->
      <div *ngSwitchCase="2" class="tabs-vps-panel vps-panel-cmp">
        <div class="vps-table-scroll">
          <table class="vps-comparison-table vps-comparison-joomla">
            <thead>
              <tr>
                <th class="vps-cmp-corner" colspan="2" scope="colgroup"></th>
                <th
                  *ngFor="let plan of plans; let hi = index"
                  class="vps-cmp-ssd-head"
                  scope="col"
                  [style.background]="cmpHeadBg[hi]">
                  {{ plan.name }}
                </th>
              </tr>
              <tr>
                <th scope="col">Característica</th>
                <th scope="col" class="vps-cmp-help-col"></th>
                <th scope="col" *ngFor="let plan of plans" class="vps-cmp-subhead">{{ plan.subtitle }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of comparisonRows" [class.vps-comparison-section]="row.section">
                <ng-container *ngIf="row.section">
                  <td [attr.colspan]="comparisonColspan()" class="vps-comparison-section-title">{{ row.section }}</td>
                </ng-container>
                <ng-container *ngIf="!row.section">
                  <td class="vps-comparison-feature">{{ row.feature }}</td>
                  <td class="vps-comparison-help">
                    <span *ngIf="row.helpText" class="vps-help" [attr.title]="row.helpText">
                      <img loading="lazy" src="assets/images/rackeo/shared/ui/ui-icono-ayuda.png" alt="Más información" />
                    </span>
                  </td>
                  <td class="vps-comparison-value" *ngFor="let cell of row.cells">
                    <img loading="lazy"
                      *ngIf="cell === 'check'"
                      class="vps-cmp-tick"
                      src="assets/images/rackeo/virtualizacion/ui/ui-tick-vps.png"
                      alt="Sí" />
                    <span *ngIf="cell !== 'check'">{{ cell }}</span>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>

        <hr class="vps-divider" />

        <div class="vps-table-scroll">
          <table class="vps-comparison-prices vps-prices-joomla">
            <thead>
              <tr>
                <th class="vps-prices-label-head" scope="col">Precios</th>
                <th
                  *ngFor="let plan of plans; let pi = index"
                  class="vps-cmp-ssd-head"
                  scope="col"
                  [style.background]="cmpHeadBg[pi]">
                  {{ plan.name }}<br />
                  <small>{{ plan.subtitle }}</small>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pr of comparisonPriceRows">
                <td class="vps-price-label">{{ pr.label }}</td>
                <td *ngFor="let v of pr.values">{{ cart.symbol }} {{ v | rackeoCurrency }} x Mes</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td *ngFor="let plan of plans" class="vps-prices-foot">
                  <a [href]="cart.buildProductUrl(plan)" target="_blank" rel="noopener noreferrer" class="vps-btn-comprar">Comprar</a>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <!-- Adicionales -->
      <div *ngSwitchCase="3" class="tabs-vps-panel vps-panel-addon">
        <div class="vps-addons">
          <article class="vps-addon" *ngFor="let addon of addOns">
            <h4 class="vps-addon-title">{{ addon.title }}</h4>
            <div class="vps-addon-mid">
              <div class="vps-addon-image">
                <img loading="lazy" [src]="addon.image" [alt]="addon.title" />
              </div>
              <div class="vps-addon-price-block">
                <p *ngIf="addon.price != null" class="vps-addon-price">
                  {{ cart.symbol }} {{ addon.price | rackeoCurrency:addon.priceDecimals }}
                </p>
                <a
                  href="#como_comprar"
                  class="vps-addon-comprar-btn"
                  (click)="scrollToComoComprar($event)">¿Cómo Comprar?</a>
              </div>
            </div>
            <p class="vps-addon-desc">{{ addon.description }}</p>
            <div *ngIf="addon.benefits?.length" class="vps-addon-benefits">
              <p class="vps-addon-benefits-label">Beneficios</p>
              <ul>
                <li *ngFor="let b of addon.benefits">{{ b }}</li>
              </ul>
            </div>
            <p *ngIf="addon.paymentHint || addon.priceNote" class="vps-addon-footer">
              {{ addon.paymentHint || addon.priceNote }}
            </p>
          </article>
        </div>

        <div class="vps-como-comprar radius4" id="como_comprar" tabindex="-1">
          <img loading="lazy" src="assets/images/rackeo/virtualizacion/como-comprar/vps-como-comprar-bubble.png" alt="Guía visual: cómo comprar productos adicionales para tu VPS" class="vps-como-comprar-bubble" />
          <h3>¿CÓMO COMPRAR?</h3>
          <p><strong>EN EL PROCESO DE COMPRA DE CUALQUIER PLAN</strong></p>
          <p>
            Para comprar uno o más productos adicionales, debes hacerlo en el momento proceso de compra ahi podras seleccionar los productos que deseas añadir a tu compra.
          </p>
          <p><strong>SI YA TENGO MI PLAN</strong></p>
          <p>
            Si tu ya compraste tu plan y deseas añadir un producto adicional debes, entrar a tu area de cliente presionar la viñeta mis servicios, seleccionar el plan vigente luego presiona el icono editar, ahi podras elegir el producto adicional que deseas
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<p *ngIf="cart.currencyHint" class="vps-tax-hint">{{ cart.currencyHint }}</p>

<section class="vps-cta-ayuda">
  <app-rackeo-cta-contact></app-rackeo-cta-contact>
</section>
